import { Api, LogManager } from "@mcleod/core";
import { AutogenLayoutPurposeSwap } from "./autogen/AutogenLayoutPurposeSwap";
import { RowEdiOrder } from "./models/ModelEdiOrder";
const log = LogManager.getLogger("lme.datafusion.PurposeSwap");

export class PurposeSwap extends AutogenLayoutPurposeSwap {
    async swapOriginalToChange(ediOrderRow: RowEdiOrder, orderId: string) {
        await Api.post("lme/datafusion/purpose-swap", {
                    tender_id: ediOrderRow.get("id"),
                    order_id: orderId,
                    original_purpose: ediOrderRow.get("purpose"),
                    new_purpose: "04"
                });

        return;
    }

    async swapChangeToOriginal(ediOrderRow: RowEdiOrder) {
        await Api.post("lme/datafusion/purpose-swap", {
                    tender_id: ediOrderRow.get("id"),
                    order_id: "",
                    original_purpose: ediOrderRow.get("purpose"),
                    new_purpose: "00"
                });

        return;
    }
}
